(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-article"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.fk-article__copy') : null;
    if (!button || !navigator.clipboard) return;

    navigator.clipboard.writeText(button.dataset.url || location.href).then(() => {
      const original = button.textContent;
      button.textContent = button.dataset.done || 'Copied';
      setTimeout(() => {
        button.textContent = original;
      }, 2000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-collection"] && !Shopify.designMode) return;
  try {
    
  // Submit the sort form on change, and drop the no-JS button.
  class FkCollectionSort extends HTMLElement {}

  document.querySelectorAll('.fk-coll__sort').forEach((form) => {
    const select = form.querySelector('.fk-coll__sort-select');
    if (!select) return;

    select.addEventListener('change', () => {
      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-drawer-extras"]) return;
  try {
    
  (() => {
    const HOST = '[data-fk-drawer-extras]';

    const inject = () => {
      const host = document.querySelector(HOST);
      if (!host) return;
      const brandTpl = host.querySelector('[data-fk-drawer-brand]');
      const footTpl = host.querySelector('[data-fk-drawer-foot]');

      document.querySelectorAll('.menu-drawer').forEach((drawer) => {
        if (brandTpl && !drawer.querySelector('.fk-drawer-brand')) {
          const brand = brandTpl.content.firstElementChild.cloneNode(true);
          const close = drawer.querySelector('.menu-drawer__close-button');
          if (close) close.insertAdjacentElement('afterend', brand);
          else drawer.prepend(brand);
        }
        if (footTpl && !drawer.querySelector('.fk-drawer-foot')) {
          drawer.append(footTpl.content.firstElementChild.cloneNode(true));
        }
      });
    };

    // The header (and with it the drawer) is re-rendered by the theme editor
    // on every setting change, and Ritual morphs it on section updates, so
    // the clones are re-checked whenever the DOM gains nodes. Debounced to
    // one pass per frame; the work is a couple of querySelectors.
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        inject();
      });
    };

    const start = () => {
      inject();
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', schedule);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-search"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fk-search .fk-coll__sort').forEach((form) => {
    const select = form.querySelector('.fk-coll__sort-select');
    if (select) select.addEventListener('change', () => form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Delegated, so it keeps working after the theme editor re-renders a
    // section and for any number of carousels on one page.
    const step = (track) => {
      const card = track.querySelector('.fk-tut__card');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const sync = (stage) => {
      const track = stage.querySelector('[data-fk-tut-track]');
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth - 2;
      stage.querySelectorAll('[data-fk-tut-dir]').forEach((btn) => {
        const dir = Number(btn.dataset.fkTutDir);
        btn.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max;
      });
    };

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-fk-tut-dir]');
      if (!btn) return;
      const stage = btn.closest('[data-fk-tut]');
      const track = stage && stage.querySelector('[data-fk-tut-track]');
      if (!track) return;
      track.scrollBy({ left: Number(btn.dataset.fkTutDir) * step(track) });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const track = event.target;
        if (track instanceof Element && track.matches('[data-fk-tut-track]')) {
          sync(track.closest('[data-fk-tut]'));
        }
      },
      true
    );

    const syncAll = () => document.querySelectorAll('[data-fk-tut]').forEach(sync);
    window.addEventListener('resize', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
